export default "__VITE_ASSET__jFIXRl8m__"